export default "__VITE_ASSET__07093d04__"